import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "16", "height": "16", "viewBox": "0 0 16 16", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M7.99999 13.9998C11.3137 13.9998 14 11.3136 14 7.99984C14 4.68613 11.3137 1.99984 7.99999 1.99984C4.68628 1.99984 1.99999 4.68613 1.99999 7.99984C1.99999 11.3136 4.68628 13.9998 7.99999 13.9998ZM15.3333 7.99984C15.3333 12.0499 12.0501 15.3332 7.99999 15.3332C3.9499 15.3332 0.666656 12.0499 0.666656 7.99984C0.666656 3.94975 3.9499 0.666504 7.99999 0.666504C12.0501 0.666505 15.3333 3.94975 15.3333 7.99984ZM4.93564 10.1214L7.05719 7.99984L4.93564 5.87829L5.87844 4.93548L7.99999 7.05704L10.1211 4.93594L11.0639 5.87875L8.94279 7.99984L11.0639 10.1209L10.1211 11.0638L7.99999 8.94264L5.87844 11.0642L4.93564 10.1214Z", "fill": "currentColor" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const CloseInputIcon = __component__.exports;
export {
  CloseInputIcon as default
};
